class EmailSubInjector {
	init() {
		const injectEmailSubTo =
			document.querySelectorAll<HTMLElement>(".email-sub-inject");
		const emailSubscribeContent = document.getElementById(
			"email-subscribe-block"
		)?.firstElementChild as HTMLElement;

		injectEmailSubTo.forEach(injectEmailSubParent => {
			const allParagraphs = Array.from(
				injectEmailSubParent.querySelectorAll<HTMLElement>("p")
			);

			let lastParagraph = allParagraphs.reverse().find(paragraph => {
				return paragraph.innerText.length > 200;
			});

			if (!lastParagraph) {
				return;
			}

			const previousElementStyles = getComputedStyle(
				lastParagraph.previousElementSibling as HTMLElement
			);

			// If the previous element is floated, or has 0 height (an image that is floated) insert the email sub element above that so the paragraph still wraps the image.
			if (
				previousElementStyles.float === "right" ||
				previousElementStyles.float === "left" ||
				previousElementStyles.height === "0px"
			) {
				lastParagraph = lastParagraph.previousElementSibling as HTMLElement;
			}

			while (lastParagraph.previousElementSibling?.tagName.toLowerCase().startsWith("h")) {
				lastParagraph = lastParagraph.previousElementSibling as HTMLElement;
			}

			const emailSubToInject = emailSubscribeContent.cloneNode(true);

			lastParagraph.parentNode?.insertBefore(emailSubToInject, lastParagraph);
		});
	}
}

document.addEventListener("DOMContentLoaded", () => {
	const emailSubInjector = new EmailSubInjector();

	emailSubInjector.init();
});
